var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.8H6C5.7 14.8 5.5 14.6 5.5 14.3C5.5 14 5.7 13.8 6 13.8H10C10.3 13.8 10.5 14 10.5 14.3C10.5 14.6 10.3 14.8 10 14.8Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 12.8999H6.00016C5.60016 12.8999 5.20016 12.5999 5.20016 12.0999V11.3999C5.20016 10.8999 5.00016 10.4999 4.60016 10.1999C3.50016 9.2999 2.80016 7.8999 2.80016 6.3999C2.70016 4.9999 3.20016 3.5999 4.20016 2.5999C5.20016 1.5999 6.50016 0.899902 7.90016 0.899902C9.30016 0.899902 10.7002 1.3999 11.7002 2.3999C12.7002 3.3999 13.3002 4.6999 13.3002 6.0999C13.3002 7.6999 12.6002 9.1999 11.4002 10.1999C11.0002 10.4999 10.8002 10.8999 10.8002 11.3999V12.0999C10.7002 12.5999 10.4002 12.8999 10.0002 12.8999ZM6.70016 11.3999H9.20016C9.20016 10.4999 9.60016 9.5999 10.3002 9.0999C11.2002 8.3999 11.7002 7.2999 11.7002 6.1999C11.7002 5.1999 11.3002 4.1999 10.6002 3.4999C9.90016 2.7999 9.00016 2.3999 7.90016 2.3999C6.90016 2.3999 5.90016 2.8999 5.20016 3.5999C4.50016 4.3999 4.10016 5.2999 4.20016 6.2999C4.30016 7.2999 4.70016 8.2999 5.60016 8.9999C6.30016 9.5999 6.70016 10.4999 6.70016 11.3999Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulb);
export default __webpack_public_path__ + "static/media/icon-bulb.513f9b971b0fe7df95a5307025986e44.svg";
export { ForwardRef as ReactComponent };